import React from "react";
/** Services Import */
import Global from "../../Services/Common/Global";
import Commons from "../../Services/Common/Common";
import Dialog from "../../Services/Common/Dialog";
import IndexedDb from "../../Services/IndexedDb/IndexedDb";
/** Components Import */
import Mm10020View from "../../Views/Manufacture/MM10020";
import Snackbar from "../../Components/Snackbar";
import BasicModal from "../../Components/Modal_Basic";

function MM10020(props) {
  const [snackbars, setSnackbars] = React.useState({
    toggle: false,
    type: "",
    message: "",
  });
  const [lanData, setLanData] = React.useState([]);
  const [rowData, setRowData] = React.useState([]);
  const [rowData1, setRowData1] = React.useState([]);
  const [changedRowData, setChangedRowData] = React.useState([]);
  const [changedRowData1, setChangedRowData1] = React.useState([]);
  const [selectedRowData, setSelectedRowData] = React.useState([]);
  const [selectedRowData1, setSelectedRowData1] = React.useState([]);
  const [authGroupGridRowData, setAuthGroupGridRowData] = React.useState([]);
  const [authGroupGridRowData2, setAuthGroupGridRowData2] = React.useState([]);
  const [selectedModalData2, setSelectedModalData2] = React.useState([]);

  const [inputs, setInputs] = React.useState({
    comboInwh: [], //창고
  });
  const [dialogToggle, setDialogToggle] = React.useState(false);
  const [userInfo, setUserInfo] = React.useState([]);
  const [saveYn, setSaveYn] = React.useState(false);
  const [checkSoNoYn, setCheckSoNoYn] = React.useState(true);
  const today = new Date();
  const monthAgo = new Date(today);
  const [startDate, setStartDate] = React.useState(
    new Date(monthAgo.setMonth(today.getMonth() - 3))
  );
  const dayAgo = new Date(today);
  const [endDate, setEndDate] = React.useState(
    new Date(dayAgo.setDate(today.getDate() + 7))
  );
  React.useEffect(() => {
    for (let i = 0; i < rowData.length; i++) {
      if (rowData[i].soNo && !rowData[i].workDt) {
        setCheckSoNoYn(false);
      }
    }
  }, [changedRowData]);
  React.useEffect(() => {
    window.addEventListener("error", (e) => {
      if (
        e.message === "ResizeObserver loop limit exceeded" ||
        e.message ===
          "ResizeObserver loop completed with undelivered notifications."
      ) {
        const resizeObserverErrDiv = document.getElementById(
          "webpack-dev-server-client- overlay-div"
        );
        const resizeObserverErr = document.getElementById(
          "webpack-dev-server-client-overlay"
        );
        if (resizeObserverErr) {
          resizeObserverErr.setAttribute("style", "display: none");
        }
        if (resizeObserverErrDiv) {
          resizeObserverErrDiv.setAttribute("style", "display: none");
        }
      }
    });
    SearchLogic();
  }, []);
  //작업지시 조회
  const SearchLogic = async () => {
    Dialog.ProgressBar(true);
    let getLanData = [];
    let getRowData = [];
    let getComboData = [];
    const forstartDate = startDate
      .toLocaleDateString("en-GB", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      })
      .split("/")
      .reverse()
      .join("-");
    const forendDate = endDate
      .toLocaleDateString("en-GB", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      })
      .split("/")
      .reverse()
      .join("-");

    try {
      await IndexedDb.GetLoginInfo().then((result) => {
        setUserInfo(result);
      });
      //창고코드
      await Commons.Axios(
        "get",
        Global.serverUrls.useUrl + Global.urls.logic.Common.GetWh,
        {
          whCd: "string",
        }
      ).then((result) => {
        let data = result.data;
        for (let i = 0; i < data.length; i++) {
          getComboData.push({
            value: data[i].value,
            name: data[i].name,
          });
        }

        inputs.comboInwh = getComboData.filter(
          (e) => e.value.substring(0, 5) === "WH_MM"
        );
      });
      await IndexedDb.GetAllDb("LanguageList").then((result) => {
        if (result.length > 0) {
          getLanData = result.filter((f) => f.lanType !== "MENU");
        }
      });
      setLanData(getLanData);
      await Commons.Axios(
        "get",
        Global.serverUrls.useUrl +
          Global.urls.logic.Manufacture.MM10020.GetSalesOrderItemdtls
      ).then((result) => {
        let data = result.data;
        if (data === "데이터가 없습니다.") {
          setSnackbars({
            toggle: true,
            type: "info",
            message: getLanData.filter(
              (f) => f.lanId === "Snack_NullData" && f.lanType === "SNACK"
            )[0].lanName,
          });
        } else if (data.type === "Error") {
          setSnackbars({
            toggle: true,
            type: "info",
            message: getLanData.filter(
              (f) => f.lanId === "Snack_NullData" && f.lanType === "SNACK"
            )[0].lanName,
          });
        } else {
          for (let i = 0; i < data.length; i++) {
            getRowData.push({
              plantCd: data[i].plantCd,
              plantNm: data[i].plantNm,
              stusNm: data[i].stusNm,
              soNo: data[i].soNo,
              itemCd: data[i].itemCd,
              itemNm: data[i].itemNm,
              custNm: data[i].custNm,
              itemQty: data[i].itemQty,
              workQty: data[i].woNo == null ? data[i].itemQty : data[i].workQty,
              wonjiQty1: data[i].wonjiQty1,
              wonjiQty2: data[i].wonjiQty2,
              bomItemCd: data[i].bomItemCd,
              bomItemNm: data[i].bomItemNm,
              soItemCost: data[i].soItemCost,
              soItemAmt: data[i].soItemAmt.toFixed(0),
              soItemVat: data[i].soItemVat.toFixed(0),
              soDueNo: data[i].soDueNo,
              soDueDt: new Date(data[i].soDueDt),
              workDt:
                data[i].workDt == null
                  ? null
                  : data[i].createDt.replace("T", " "),
              soDt: data[i].soDt
                ? Commons.DateFormating(data[i].soDt.toString(), 2)
                : "",
              woNo: data[i].woNo,
              whCd: data[i].whCd,
              whNm: data[i].whNm,
              updateId: data[i].mfUpdateId
                ? data[i].mfUpdateId
                : data[i].updateId,
            });
          }
          setRowData(Commons.InsertNumber(getRowData));
          setCheckSoNoYn(true);
        }
      });
    } catch (e) {
      if (e.response.status === 401) {
        setSnackbars({
          toggle: true,
          type: "error",
          message: "로그인 정보가 만료되었습니다.",
        });
      } else {
        setSnackbars({
          toggle: true,
          type: "error",
          message: e.message,
        });
      }
    } finally {
      Dialog.ProgressBar(false);
    }
  };

  //재고현황 조회
  const SearchStockItemLogic = async (_itemCd) => {
    Dialog.ProgressBar(true);
    let getLanData = [];
    let getRowData = [];

    try {
      await IndexedDb.GetAllDb("LanguageList").then((result) => {
        if (result.length > 0) {
          getLanData = result.filter((f) => f.lanType !== "MENU");
        }
      });
      setLanData(getLanData);
      await Commons.Axios(
        "get",
        Global.serverUrls.useUrl +
          Global.urls.logic.Manufacture.MM10020.GetStockItem,
        {
          itemCd: _itemCd,
        }
      ).then((result) => {
        let data = result.data;
        if (data === "데이터가 없습니다.") {
          setSnackbars({
            toggle: true,
            type: "info",
            message: lanData.filter(
              (f) => f.lanId === "Snack_NullData" && f.lanType === "SNACK"
            )[0].lanName,
          });
        } else if (data.type === "Error") {
          setSnackbars({
            toggle: true,
            type: "info",
            message: lanData.filter(
              (f) => f.lanId === "Snack_NullData" && f.lanType === "SNACK"
            )[0].lanName,
          });
        } else {
          for (let i = 0; i < data.length; i++) {
            getRowData.push({
              plantCd: data[i].plantCd,
              stockDt: data[i].stockDt
                ? Commons.DateFormating(data[i].stockDt.toString(), 2)
                : "",
              itemCd: data[i].itemCd,
              itemNm: data[i].itemNm,
              itemStd: data[i].itemStd,
              stockQty: data[i].stockQty,
            });
          }
          setRowData1(Commons.InsertNumber(getRowData));
        }
      });
    } catch (e) {
      setSnackbars({
        toggle: true,
        type: "error",
        message: e.message,
      });
    } finally {
      Dialog.ProgressBar(false);
    }
  };

  //주문현황 조회(헬퍼)
  const SearchSalesOrdersLogic = async (_itemCd) => {
    Dialog.ProgressBar(true);
    let getLanData = [];
    let getRowData = [];

    try {
      await IndexedDb.GetAllDb("LanguageList").then((result) => {
        if (result.length > 0) {
          getLanData = result.filter((f) => f.lanType !== "MENU");
        }
      });
      setLanData(getLanData);
      await Commons.Axios(
        "get",
        Global.serverUrls.useUrl +
          Global.urls.logic.Manufacture.MM10020.GetSalesOrders,
        {
          itemCd: _itemCd,
        }
      ).then((result) => {
        let data = result.data;
        if (data === "데이터가 없습니다.") {
          setSnackbars({
            toggle: true,
            type: "info",
            message: lanData.filter(
              (f) => f.lanId === "Snack_NullData" && f.lanType === "SNACK"
            )[0].lanName,
          });
        } else if (data.type === "Error") {
          setSnackbars({
            toggle: true,
            type: "info",
            message: lanData.filter(
              (f) => f.lanId === "Snack_NullData" && f.lanType === "SNACK"
            )[0].lanName,
          });
        } else {
          for (let i = 0; i < data.length; i++) {
            let year = new Date(data[i].soDueDt).getFullYear();
            let month = new Date(data[i].soDueDt).getMonth() + 1;
            let day = new Date(data[i].soDueDt).getDate() + i;

            getRowData.push({
              plantCd: data[i].plantCd,
              soNo: data[i].soNo,
              itemCd: data[i].itemCd,
              itemNm: data[i].itemNm,
              itemQty: data[i].itemQty,
              soDueDt:
                year +
                "-" +
                month.toString().padStart(2, "0") +
                "-" +
                day.toString().padStart(2, "0"),
            });
          }
          setAuthGroupGridRowData(Commons.InsertNumber(getRowData));
        }
      });
    } catch (e) {
      setSnackbars({
        toggle: true,
        type: "error",
        message: e.message,
      });
    } finally {
      Dialog.ProgressBar(false);
    }
  };

  const Print = async () => {
    let headerData = [];
    let tableData = [];
    let address;

    //var ItemInfo = itemList.find(f => f.ItemCd == viewModel.DataItem.ItemCd);
    //address = "http://114.206.84.134:5540/ManufactureManagement/WorkOrderManagement"; //http://localhost:65061/ 114.206.84.134:5540
    address =
      "https://dongsungprintingmes.com:8082/ManufactureManagement/WorkOrderManagement"; //http://localhost:65061/ 114.206.84.134:5540

    if (
      selectedRowData.length === 0 ||
      selectedRowData[0].woNo === "" ||
      selectedRowData[0].woNo === null
    ) {
      setSnackbars({
        toggle: true,
        type: "info",
        message: "작업을 선택해주세요.",
      });
    } else {
      await Commons.Axios(
        "get",
        Global.serverUrls.useUrl +
          Global.urls.logic.Manufacture.MM10020.GetPrintData,
        {
          soNo: selectedRowData[0].soNo,
          itemCd: selectedRowData[0].itemCd,
          soDueDt: Commons.DateStrChange(selectedRowData[0].soDueDt),
        }
      ).then((result) => {
        let data = result.data;
        headerData.push({
          ReportTitle: "작업 지시서",
          WoNo: selectedRowData[0].woNo, //작업지시번호
          WorkDt: Commons.DateStrChange(selectedRowData[0].workDt), //작업지시일자
          CustNm: data[0].custNm, //거래처
          ItemNm: data[0].itemNm, //품명
          itemCd: data[0].itemCd, //품목코드
          WorkQty: selectedRowData[0].workQty, // 지시수량,
          ItemCaution: data[0].itemCaution, //주의사항
          SoDueDt: data[0].soDueDt, //납기일
          ItemStd: data[0].itemStd, //규격
          ItemStd2: data[0].itemStd2, //규격
          ItemWonJi1: data[0].itemWonji1, //원지1
          ItemWonJi2: data[0].itemWonji2, //원지2
          Wonji1Qty: selectedRowData[0].wonjiQty1, //원지1 재단수량
          Wonji2Qty: selectedRowData[0].wonjiQty2, //원지2 재단수량
          ItemPlateMaking: data[0].itemPlateMaking, //제판
          ItemCarton: data[0].itemCarton, //카톤
          ItemVinyl: data[0].itemVinyl, //비닐
          ItemPrint: data[0].itemPrint, //인쇄
          ItemRamie: data[0].itemRamie, //라미
          ItemSpecialPrice1: data[0].itemSpecialPrice1, //특수가공1
          ItemSpecialPrice2: data[0].itemSpecialPrice2, //특수가공2
          ItemJedae: data[0].itemJedae, //제대
          ItemThompson: data[0].itemThompson, //톰슨
          ItemString: data[0].itemString, //끈
          ItemLaminated: data[0].itemLaminated, //합지
          ItemSide: data[0].itemSide, //사이드
          ItemHole: data[0].itemHole, //구멍쇠
          ItemUpperPod: data[0].itemUpperPod, //상깍지
          ItemLowPod: data[0].itemLowPod, //하깍지
          PersonCharg: data[0].personCharg, //담당자
          Reamrk: data[0].reamrk, //기타
        });
        var f = document.createElement("form");
        f.action = address; //192.168.10.252:8081  //192.168.254.33:8081
        f.method = "POST";
        f.target = "_blank";

        var k = document.createElement("input");
        k.type = "hidden";
        k.name = "headerData";
        k.value = JSON.stringify(headerData);
        f.append(k);

        var l = document.createElement("input");
        l.type = "hidden";
        l.name = "tableData";
        l.value = JSON.stringify(tableData);
        f.append(l);
        document.body.appendChild(f);
        f.submit();
      });
    }
  };
  //자재등록 BOM 조회
  const SearchItemBomLogic = async (_soNo, _soDueDt, _itemCd) => {
    Dialog.ProgressBar(true);
    let getLanData = [];
    let getRowData = [];
    let totalbomAmt = null;
    try {
      await Commons.Axios(
        "get",
        Global.serverUrls.useUrl +
          Global.urls.logic.Manufacture.MM10020.GetItemBom,
        {
          soNo: _soNo,
          soDueDt: Commons.DateStrChange(_soDueDt),
          itemCd: _itemCd,
        }
      ).then((result) => {
        let data = result.data;
        if (data === "데이터가 없습니다.") {
          setSnackbars({
            toggle: true,
            type: "info",
            message: lanData.filter(
              (f) => f.lanId === "Snack_NullData" && f.lanType === "SNACK"
            )[0].lanName,
          });
        } else if (data.type === "Error") {
          setSnackbars({
            toggle: true,
            type: "info",
            message: lanData.filter(
              (f) => f.lanId === "Snack_NullData" && f.lanType === "SNACK"
            )[0].lanName,
          });
        } else {
          for (let i = 0; i < data.length; i++) {
            getRowData.push({
              whNm: data[i].whNm,
              whCd: data[i].whCd,
              plantCd: data[i].plantCd,
              bomItemCd: data[i].itemCd,
              itemNm: data[i].itemNm,
              orSeq: data[i].orSeq,
              itemType: data[i].itemType,
              itemTypeNm: data[i].itemTypeNm,
              remark: data[i].remark,
              itemStdAmt: data[i].itemStdAmt,
              bomItemUseage: data[i].bomItemUseage,
              totalAmt: data[i].totalAmt,
              processCd: data[i].processCd,
              processNm: data[i].processNm,
            });
          }
        }
        setAuthGroupGridRowData(getRowData);
      });
    } catch (e) {
      setSnackbars({
        toggle: true,
        type: "error",
        message: e.message,
      });
    } finally {
      Dialog.ProgressBar(false);
    }
  };
  const SaveConfirm = (_type) => {
    Dialog.Confirm(
      lanData.filter(
        (f) => f.lanId === "Dia_Title_WorkInstruction" && f.lanType === "DIALOG"
      )[0].lanName,
      `관리자: ${userInfo.userId}
        ${
          lanData.filter(
            (f) =>
              f.lanId === "Dia_Message_WorkInstruction" &&
              f.lanType === "DIALOG"
          )[0].lanName
        }
      `,

      lanData.filter(
        (f) => f.lanId === "Dia_Btn_Confirm" && f.lanType === "DIALOG"
      )[0].lanName,
      () => {
        SaveLogic();
      }
    );
  };
  //자재등록 수정 및 저장
  const CreateWorkOrderBom = async () => {
    Dialog.ProgressBar(true);
    let userInfo = null;
    let bomData = [];
    try {
      await IndexedDb.GetLoginInfo().then((result) => {
        userInfo = result;
      });
      for (let i = 0; i < authGroupGridRowData.length; i++) {
        bomData.push({
          whCd: authGroupGridRowData[i].whCd,
          soNo: selectedRowData[0].soNo,
          soDueDt: Commons.DateStrChange(selectedRowData[0].soDueDt),
          woNo: selectedRowData[0].woNo,
          itemCd: selectedRowData[0].itemCd,
          bomItemCd: authGroupGridRowData[i].bomItemCd,
          bomItemUseage: authGroupGridRowData[i].bomItemUseage,
          remark: authGroupGridRowData[i].remark,
          createId: userInfo.userId,
          createDate: Commons.DateStrChange(new Date()),
          updateId: userInfo.userId,
          updateDate: Commons.DateStrChange(new Date()),
        });
      }
      await Commons.Axios(
        "post",
        Global.serverUrls.useUrl +
          Global.urls.logic.Manufacture.MM10020.CreateWorkOrderBom,
        bomData
      ).then((result) => {
        let data = result.data;
      });
    } catch (e) {
      setSnackbars({
        toggle: true,
        type: "error",
        message: e.message,
      });
    } finally {
      Dialog.ProgressBar(false);
      setRowData1([]);
    }
  };
  //자재등록 삭제
  const DeleteBomLogic = async () => {
    Dialog.ProgressBar(true);
    let userInfo = {};
    let deleteData = [];
    try {
      await IndexedDb.GetLoginInfo().then((result) => {
        userInfo = result;
      });
      for (let i = 0; i < selectedModalData2.length; i++) {
        deleteData.push({
          // itemCd: authGroupGridRowData[i].itemCd,
          itemCd: selectedRowData[0].itemCd,
          bomItemCd: selectedModalData2[i].itemCd,
          soNo: selectedRowData[0].soNo,
          soDueDt: Commons.DateStrChange(selectedRowData[0].soDueDt),
          updateId: userInfo.userId,
          updateDate: new Date(),
        });
      }
      await Commons.Axios(
        "post",
        Global.serverUrls.useUrl +
          Global.urls.logic.Manufacture.MM10020.DeleteWorkOrderBom,
        deleteData
      ).then((result) => {
        let data = result.data;
        if (data !== "Ok") {
          setSnackbars({
            toggle: true,
            type: "error",
            message: data,
          });
        } else {
          setSnackbars({
            toggle: true,
            type: "success",
            message: lanData.filter(
              (f) => f.lanId === "Snack_Delete" && f.lanType === "SNACK"
            )[0].lanName,
          });
          SearchItemBomLogic(
            selectedRowData[0].soNo,
            new Date(selectedRowData[0].soDueDt),
            selectedRowData[0].itemCd
          );
        }
      });
    } catch (e) {
      setSnackbars({
        toggle: true,
        type: "error",
        message: e.message,
      });
    } finally {
      Dialog.ProgressBar(false);
    }
  };
  const SaveLogic = async () => {
    Dialog.ProgressBar(true);
    let userInfo = null;
    let salesOrders = [];
    try {
      await IndexedDb.GetLoginInfo().then((result) => {
        userInfo = result;
      });
      if (!selectedRowData[0]) {
        setSnackbars({
          toggle: true,
          type: "info",
          message: lanData.filter(
            (f) => f.lanId === "Snack_ ChoseProcess" && f.lanType === "SNACK" //이미 처리된 작업지시입니다.
          )[0].lanName,
        });
        return false;
      } else if (selectedRowData.length < 0) {
        setSnackbars({
          toggle: true,
          type: "info",
          message: lanData.filter(
            (f) => f.lanId === "Snack_ ChoseProcess" && f.lanType === "SNACK" //이미 처리된 작업지시입니다.
          )[0].lanName,
        });
        return false;
      } else if (
        selectedRowData[0].stusNm == "생산중" ||
        selectedRowData[0].stusNm == "생산완료"
      ) {
        setSnackbars({
          toggle: true,
          type: "info",
          message: lanData.filter(
            (f) => f.lanId === "Snack_AlreadyProcess" && f.lanType === "SNACK" //이미 처리된 작업지시입니다.
          )[0].lanName,
        });
        return false;
      } else if (
        // selectedRowData[0].stusNm == "출하지시" ||
        selectedRowData[0].stusNm == "출하" ||
        selectedRowData[0].stusNm == "납품"
      ) {
        setSnackbars({
          toggle: true,
          type: "info",
          message: lanData.filter(
            (f) => f.lanId === "Snack_AlreadyDeliv" && f.lanType === "SNACK" //이미 출하된 작업지시입니다.
          )[0].lanName,
        });
        return false;
      }
      if (selectedRowData[0].whNm == null) {
        setSnackbars({
          toggle: true,
          type: "info",
          message: lanData.filter(
            (f) =>
              f.lanId === "Snack_SelectProductionWh" && f.lanType === "SNACK" //창고코드를 입력하세요.
          )[0].lanName,
        });
        return false;
      }
      if (selectedRowData[0].wonjiQty1 == null) {
        setSnackbars({
          toggle: true,
          type: "info",
          message: lanData.filter(
            (f) => f.lanId === "Snack_Wonji1" && f.lanType === "SNACK" //원지1은 필수입력입니다..
          )[0].lanName,
        });
        return false;
      }
      for (let i = 0; i < selectedRowData.length; i++) {
        salesOrders.push({
          plantCd: selectedRowData[i].plantCd,
          woNo: selectedRowData[i].woNo,
          itemCd: selectedRowData[i].itemCd,
          soNo: selectedRowData[i].soNo,
          workDt: Commons.DateStrChange(selectedRowData[i].workDt),
          soDueDt: Commons.DateStrChange(selectedRowData[i].soDueDt),
          wonji1Qty: selectedRowData[i].wonjiQty1,
          wonji2Qty: selectedRowData[i].wonjiQty2,
          workQty: selectedRowData[i].workQty,
          planDt: selectedRowData[i].planDt,
          whCd: selectedRowData[i].whNm.value,
          createId: userInfo.userId,
          createDate: Commons.DateStrChange(new Date()),
          updateId: userInfo.userId,
          updateDate: Commons.DateStrChange(new Date()),
        });
      }
      await Commons.Axios(
        "post",
        Global.serverUrls.useUrl +
          Global.urls.logic.Manufacture.MM10020.CreateWorkOrder,
        salesOrders
      ).then((result) => {
        let data = result.data;
        if (data == "NULLBOM") {
          setSnackbars({
            toggle: true,
            type: "info",
            message: lanData.filter(
              (f) => f.lanId === "Snack_CheckBomYn" && f.lanType === "SNACK"
            )[0].lanName,
          });
        } else if (data === "BOM을 등록하세요") {
          setSnackbars({
            toggle: true,
            type: "error",
            message: "BOM을 등록하세요",
          });
        } else if (data === "수량을 확인해주세요") {
          setSnackbars({
            toggle: true,
            type: "error",
            message: lanData.filter(
              (f) => f.lanId === "Snack_CheckBomQty" && f.lanType === "SNACK"
            )[0].lanName,
          });
        } else {
          if (data !== "Ok") {
            setSnackbars({
              toggle: true,
              typ: "error",
              message: data,
            });
          } else {
            setSnackbars({
              toggle: true,
              type: "success",
              message: lanData.filter(
                (f) => f.lanId === "Snack_Save" && f.lanType === "SNACK"
              )[0].lanName,
            });
            SearchLogic();
            setSaveYn(false);
            setCheckSoNoYn(true);
          }
        }
      });
    } catch (e) {
      setSnackbars({
        toggle: true,
        type: "error",
        message: e.message,
      });
    } finally {
      Dialog.ProgressBar(false);
      setRowData1([]);
    }
  };
  //품목설정
  const GetItemList = async (_value) => {
    Dialog.ProgressBar(true);
    let getLanData = [];
    let getRowData = [];

    try {
      await IndexedDb.GetAllDb("LanguageList").then((result) => {
        if (result.length > 0) {
          getLanData = result.filter((f) => f.lanType !== "MENU");
        }
      });
      setLanData(getLanData);
      await Commons.Axios(
        "get",
        Global.serverUrls.useUrl + Global.urls.logic.Stock.ST10030.GetStockList,
        {
          // plantCd: "string",
          // value: _value === "" ? "string" : _value,
          startDate: new Date(startDate),
          endDate: endDate,
        }
      ).then((result) => {
        let data = result.data;
        if (data === "데이터가 없습니다.") {
          setSnackbars({
            toggle: true,
            type: "info",
            message: lanData.filter(
              (f) => f.lanId === "Snack_NullData" && f.lanType === "SNACK"
            )[0].lanName,
          });
          setAuthGroupGridRowData([]);
        } else if (data.type === "Error") {
          setSnackbars({
            toggle: true,
            type: "info",
            message: lanData.filter(
              (f) => f.lanId === "Snack_NullData" && f.lanType === "SNACK"
            )[0].lanName,
          });
          setAuthGroupGridRowData([]);
        } else {
          for (let i = 0; i < data.length; i++) {
            getRowData.push({
              plantCd: data[i].plantCd,
              plantNm: data[i].plantNm,
              itemCd: data[i].itemCd,
              itemNm: data[i].itemNm,
              itemStd: data[i].itemStd,
              itemFormula: data[i].itemFormula,
              soItemAmt: data[i].stockQty * data[i].itemStdAmt,
              itemType: data[i].itemType,
              whNm: data[i].whNm,
              whCd: data[i].whCd,
              itemUnit: data[i].itemUnit,
              itemStdAmt:
                data[i].itemVatYn === "N"
                  ? data[i].itemStdAmt
                  : data[i].itemStdAmt * 1.1,
              stockQty: data[i].stockQty,
              stockAddQty: Commons.splitReserveFun(
                data[i].stockQty,
                data[i].itemFormula ? data[i].itemFormula : 1
              ),
            });
          }
          setAuthGroupGridRowData2(Commons.InsertNumber(getRowData));
        }
      });
    } catch (e) {
      setSnackbars({
        toggle: true,
        type: "error",
        message: e.message,
      });
    } finally {
      Dialog.ProgressBar(false);
    }
  };
  const DeleteConfirm = (_type) => {
    Dialog.Confirm(
      lanData.filter(
        (f) => f.lanId === "Dia_Title_Delete" && f.lanType === "DIALOG"
      )[0].lanName,
      lanData.filter(
        (f) => f.lanId === "Dia_Message_Delete" && f.lanType === "DIALOG"
      )[0].lanName,
      lanData.filter(
        (f) => f.lanId === "Dia_Btn_Confirm" && f.lanType === "DIALOG"
      )[0].lanName,
      () => {
        DeleteLogic();
      }
    );
  };

  const DeleteLogic = async () => {
    Dialog.ProgressBar(true);
    let userInfo = {};
    let deleteData = [];
    try {
      await IndexedDb.GetLoginInfo().then((result) => {
        userInfo = result;
      });
      for (let i = 0; i < selectedRowData.length; i++) {
        deleteData.push({
          plantCd: selectedRowData[i].plantCd,
          woNo: selectedRowData[i].woNo,
          itemCd: selectedRowData[i].itemCd,
          soNo: selectedRowData[i].soNo,
          soDueDt: Commons.DateStrChange(selectedRowData[i].soDueDt),
          workDt: selectedRowData[i].workDt,
          workQty: selectedRowData[i].workQty,
          createId: userInfo.userId,
          createDate: new Date(),
          updateId: userInfo.userId,
          updateDate: new Date(),
        });
      }

      await Commons.Axios(
        "post",
        Global.serverUrls.useUrl +
          Global.urls.logic.Manufacture.MM10020.DeleteWorkOrder,
        deleteData
      ).then((result) => {
        let data = result.data;
        if (data !== "Ok") {
          setSnackbars({
            toggle: true,
            type: "error",
            message: data,
          });
        } else {
          SearchLogic();
          setSnackbars({
            toggle: true,
            type: "success",
            message: lanData.filter(
              (f) => f.lanId === "Snack_Delete" && f.lanType === "SNACK"
            )[0].lanName,
          });
        }
      });
    } catch (e) {
      setSnackbars({
        toggle: true,
        type: "error",
        message: e.message,
      });
    } finally {
      Dialog.ProgressBar(false);
    }
  };

  //재고체크버튼
  const CheckStockLogic = async (_itemCd, _workQty) => {
    Dialog.ProgressBar(true);
    let getLanData = [];
    let getRowData = [];
    let lossQty = null;
    try {
      if (!_itemCd) {
        throw new Error("데이터를 선택해주세요");
      } else if (_workQty === "" || _workQty === null) {
        throw new Error("지시수량을 입력해주세요");
      }
      // else if (!selectedRowData[0].soNo) {
      //   throw new Error("주문번호를 설정해주세요");
      // }
      await IndexedDb.GetAllDb("LanguageList").then((result) => {
        if (result.length > 0) {
          getLanData = result.filter((f) => f.lanType !== "MENU");
        }
      });
      setLanData(getLanData);
      await Commons.Axios(
        "get",
        Global.serverUrls.useUrl +
          Global.urls.logic.Manufacture.MM10020.GetStockChk,
        {
          itemCd: _itemCd,
          workQty: _workQty,
          // workDt: formattedDate,
        }
      ).then((result) => {
        let data = result.data;
        if (data === "데이터가 없습니다.") {
          setSnackbars({
            toggle: true,
            type: "info",
            message: data,
          });
        } else if (data.type === "Error") {
          setSnackbars({
            toggle: true,
            type: "info",
            message: "데이터가 없습니다.",
          });
        } else {
          for (let i = 0; i < data.length; i++) {
            getRowData.push({
              plantCd: data[i].plantCd,
              stockDt: data[i].stockDt
                ? Commons.DateFormating(data[i].stockDt.toString(), 2)
                : "",
              itemCd: data[i].itemCd,
              itemNm: data[i].itemNm,
              itemStd: data[i].itemStd,
              stockQty: data[i].stockQty !== 0 ? data[i].stockQty : "0",
              usedQty: data[i].usedQty !== 0 ? data[i].usedQty : "0",
              lossQty:
                data[i].stockQty - data[i].usedQty < 0
                  ? data[i].stockQty - data[i].usedQty
                  : "0",
            });

            if (data[i].stockQty < data[i].usedQty) {
              setSaveYn(false);
              setChangedRowData([]);
              setRowData1(Commons.InsertNumber(getRowData));
              // throw new Error("수량이 부족합니다.");
            } else {
              setSaveYn(true);
            }
          }
          setRowData1(Commons.InsertNumber(getRowData));
        }
      });
    } catch (e) {
      setSnackbars({
        toggle: true,
        type: "error",
        message: e.message,
      });
    } finally {
      Dialog.ProgressBar(false);
    }
  };

  return (
    <>
      <Mm10020View
        rowData={rowData}
        setRowData={setRowData}
        rowData1={rowData1}
        setRowData1={setRowData1}
        changedRowData={changedRowData}
        setChangedRowData={setChangedRowData}
        GetItemList={GetItemList}
        setSelectedRowData={setSelectedRowData}
        selectedRowData={selectedRowData}
        changedRowData1={changedRowData1}
        setChangedRowData1={setChangedRowData1}
        setSelectedRowData1={setSelectedRowData1}
        startDate={startDate}
        CreateWorkOrderBom={CreateWorkOrderBom}
        setStartDate={setStartDate}
        SearchItemBomLogic={SearchItemBomLogic}
        endDate={endDate}
        setSelectedModalData2={setSelectedModalData2}
        selectedModalData2={selectedModalData2}
        setEndDate={setEndDate}
        SearchStockItemLogic={SearchStockItemLogic}
        authGroupGridRowData={authGroupGridRowData}
        setAuthGroupGridRowData={setAuthGroupGridRowData}
        SearchSalesOrdersLogic={SearchSalesOrdersLogic}
        SaveConfirm={SaveConfirm}
        DeleteConfirm={DeleteConfirm}
        CheckStockLogic={CheckStockLogic}
        saveYn={saveYn}
        SearchLogic={SearchLogic}
        Print={Print}
        authGroupGridRowData2={authGroupGridRowData2}
        setAuthGroupGridRowData2={setAuthGroupGridRowData2}
        inputs={inputs}
        setInputs={setInputs}
        setSaveYn={setSaveYn}
        checkSoNoYn={checkSoNoYn}
        setCheckSoNoYn={setCheckSoNoYn}
        lanData={lanData}
        DeleteBomLogic={DeleteBomLogic}
        setDialogToggle={setDialogToggle}
        setSnackbars={setSnackbars}
      />
      {snackbars.toggle && (
        <Snackbar snackbars={snackbars} setSnackbars={setSnackbars} />
      )}{" "}
      {dialogToggle && (
        <BasicModal
          onClose={() => setDialogToggle(false)}
          name={
            lanData.filter(
              (f) =>
                f.lanId === "Dia_Title_WorkInstruction" &&
                f.lanType === "DIALOG"
            )[0].lanName
          }
          titleNmae={"modal-title-sub "}
          footer={"modal-title-sub "}
          button1Background="rgb(48, 133, 214)"
          button2Background="rgb(221, 51, 51)"
          children={
            <div>
              <div
                style={{
                  fontSize: "20px",
                  textAlign: "center",
                  fontWeight: "bold",
                  margin: "10px,10px,10px,10px",
                }}
              >
                관리자: {userInfo.userId}
              </div>
              <br />
              <br />
              <div
                style={{
                  fontSize: "20px",
                  textAlign: "center",
                  margin: "10px,10px,10px,10px",
                }}
              >
                {
                  lanData.filter(
                    (f) =>
                      f.lanId === "Dia_Message_WorkInstruction" &&
                      f.lanType === "DIALOG"
                  )[0].lanName
                }
              </div>
            </div>
          }
          buttonName1={
            lanData.filter(
              (f) => f.lanId === "Dia_Btn_Confirm" && f.lanType === "DIALOG"
            )[0].lanName
          }
          execLogic={() => {
            SaveLogic();
          }}
        />
      )}
    </>
  );
}

export default MM10020;
